var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 19.4583H6.25C3.5 19.4583 3.125 17.9583 3.125 16.3333V9.0166C3.125 8.67493 3.40833 8.3916 3.75 8.3916C4.09167 8.3916 4.375 8.67493 4.375 9.0166V16.3333C4.375 17.7833 4.625 18.2083 6.25 18.2083H13.75C15.375 18.2083 15.625 17.7833 15.625 16.3333V9.0166C15.625 8.67493 15.9083 8.3916 16.25 8.3916C16.5917 8.3916 16.875 8.67493 16.875 9.0166V16.3333C16.875 17.9583 16.5 19.4583 13.75 19.4583Z",
    fill: "#4F5B92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 9.45817H4.16669C2.15002 9.45817 1.04169 8.34984 1.04169 6.33317V4.6665C1.04169 2.64984 2.15002 1.5415 4.16669 1.5415H15.8334C17.85 1.5415 18.9584 2.64984 18.9584 4.6665V6.33317C18.9584 8.34984 17.85 9.45817 15.8334 9.45817ZM4.16669 2.7915C2.85002 2.7915 2.29169 3.34984 2.29169 4.6665V6.33317C2.29169 7.64984 2.85002 8.20817 4.16669 8.20817H15.8334C17.15 8.20817 17.7084 7.64984 17.7084 6.33317V4.6665C17.7084 3.34984 17.15 2.7915 15.8334 2.7915H4.16669Z",
    fill: "#4F5B92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5167 12.7915H8.48334C8.14167 12.7915 7.85834 12.5082 7.85834 12.1665C7.85834 11.8248 8.14167 11.5415 8.48334 11.5415H11.5167C11.8583 11.5415 12.1417 11.8248 12.1417 12.1665C12.1417 12.5082 11.8583 12.7915 11.5167 12.7915Z",
    fill: "#4F5B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.8d7e207af4953f16779eb378f4347770.svg";
export { ForwardRef as ReactComponent };